import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import PropTypes from 'prop-types';

/**
 * Basic input checkbox with label.
 */
const Checkbox = forwardRef((props, ref) => {
  const {
    children, value, inline, checked, onChange, className, id,disabled,
  } = props;

  const [checkedState, setCheckedState] = useState(checked);

  const handleChange = (e) => {
    onChange(e);
  };

  useEffect(() => {
    setCheckedState(checked);
  }, [checked]);

  useImperativeHandle(ref, () => ({
    updateValue(newValue) {
      setCheckedState(newValue);
    },
  }));

  return (
    <div className={`form-check ${inline ? 'form-check-inline' : ''} ${className}`} id={id}>
      <input className="form-check-input" id={id} type="checkbox" disabled={disabled} onChange={handleChange} value={value} checked={checkedState} />
      <label className="form-check-label" htmlFor={id}>{children}</label>
    </div>
  );
});

Checkbox.propTypes = {
  /**
   * Id of input checkbox
   */
  id: PropTypes.string,
  /**
   * Label text
   */
  children: PropTypes.string,
  /**
   * Value to send when the checkbox is clicked
   */
  value: PropTypes.string,
  /**
   * Print the checkbox inline or block
   */
  inline: PropTypes.bool,
  /**
   * The checkbox is checked
   */
  // checked: PropTypes.bool,
   /**
   * The disabled
   */
    disabled: PropTypes.bool,
  /**
   * Function to bind onChange HTML functionality
   */
  onChange: PropTypes.func,
  /**
   * Custom css class
   */
  className: PropTypes.string,
};

Checkbox.defaultProps = {
  id: '',
  inline: false,
  checked: false,
  disabled:false,
  value: '',
  children: '',
  onChange: () => {},
  className: '',
};

export default Checkbox;
